import { GroupEditMode } from "@/Administration/Models/UI/Group/GroupEditMode";
import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import { EmployeeGroupUIModel } from "@/Common/Models/UI/Employee/EmployeeGroupUIModel";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";

class AdministrationGroupResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.Myle_AdministrationGetEmployeeGroups, this.getAllSearchableGroups);
        this.RegisterOperation(ServerOperations.Server.Myle_Admin_LoadGroupSetting, this.getGroupInfo);
        this.RegisterOperation(ServerOperations.Server.Myle_Admin_UpsertGroupSetting, this.upsertGroup);
        this.RegisterOperation(ServerOperations.Server.Employee_DeleteClickableTextSection, this.deleteClickableTextsection);
        this.RegisterOperation(ServerOperations.Server.GetClickableTextDetailsSpecificUserSpecificTab, this.getClickableTextDetailsSpecificGroupSpecificTab);
        this.RegisterOperation(ServerOperations.Server.Employee_GetClickableTextCategories, this.getClickableTextForSpecificContext);
        this.RegisterOperation(ServerOperations.Server.Employee_getClickableTextDetails, this.getClickableTextDetails);
        this.RegisterOperation(ServerOperations.Server.GetAllGroupsWithClickableText, this.loadAllGroupsWithClickableText);
        this.RegisterOperation(ServerOperations.Server.Import_ClickableText_List, this.importClickableText);
        this.RegisterOperation(ServerOperations.Server.GetClickableTextSpecificUser, this.getClickableTextSpecificUser);
        this.RegisterOperation(ServerOperations.Server.GetClickableTextSpecificUser, this.getAllClickableText);
        this.RegisterOperation(ServerOperations.Server.Create_List_ClickableText, this.createListOfClickableText);
        this.RegisterOperation(ServerOperations.Server.Myle_Admin_RenameGroup, this.updateGroupName);
    }

    private getAllSearchableGroups(response: ServerEvent, store: AdministrationStore): void {
        let groupResponseList: EmployeeGroup[] = response.Data["EmployeeGroupCache"];
        let groupsSearch: EmployeeGroupUIModel[] = [];

        for (let group of groupResponseList) {
            groupsSearch.push(EmployeeGroupUIModel.fromCompositeObject(group));
        }

        if (groupResponseList != null) {
            store.groupTabModel = store.groupTabModel.set("SearchGroupResult", groupsSearch.sortByProperty(x => x.Model.Name));
        }
    }

    private getGroupInfo(response: ServerEvent, store: AdministrationStore): void {
        let employeeGroup: EmployeeGroup = response.Data["EmployeeGroup"];

        if (employeeGroup != null) {
            cacheStore.RefreshEmployeeGroup(employeeGroup);
            let group = EmployeeGroupUIModel.fromCompositeObject(employeeGroup);
            store.groupTabModel = store.groupTabModel.set("PDFSearchKeywords", group.getArrayAllowedTags());
            let currentTagNames = store.groupTabModel.get("PDFSearchKeywords");
            store.groupTabModel = store.groupTabModel.set("SelectePDFTagIds", group.getCurrentTagNames(currentTagNames));
            store.groupTabModel = store.groupTabModel.set("SelectedGroup", group.clone());
            store.groupTabModel = store.groupTabModel.set("EditedGroup", group.clone());
        }
    }

    private upsertGroup(response: ServerEvent, store: AdministrationStore): void {
        let IsSuccess = response.Data["IsSuccess"];
        let groupId = response.Data["CreatedGroupId"];
        if (IsSuccess && groupId != null) {
            store.groupAction.getAllSearchableGroups();
            store.groupTabModel = store.groupTabModel.set("GroupEditMode", GroupEditMode.View);
            store.groupTabModel = store.groupTabModel.set("EditedGroup", null);
            store.groupTabModel = store.groupTabModel.set("SelectedGroup", null);
            store.groupTabModel = store.groupTabModel.set("SelectePDFTagIds", null);
            store.groupTabModel = store.groupTabModel.set("GroupName", "");
            store.groupTabModel = store.groupTabModel.set("NewUsefulLink", "");
            // refresh group
            store.groupAction.GetGroupInfo(groupId);
        }
    }

    private deleteClickableTextsection(response: ServerEvent, store: AdministrationStore): void {
        let isSuccess: boolean = response.Data["IsSuccess"];
        if (isSuccess) {
            let editGroup = store.groupTabModel.get("EditedGroup");
            window.setTimeout(
                () => store.groupAction.getAllCliackableText(editGroup.Model.Id),
                200
            );
        }
    }

    private getClickableTextDetailsSpecificGroupSpecificTab(response: ServerEvent, store: AdministrationStore): void {
        let textList: ClickableTextItem[] = response.Data["TextList"];
        if (textList != null)
            store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetailsForSpecificGroup", textList.sortByProperty(x => x.TabOrderIndex));
    }

    private getClickableTextForSpecificContext(response: ServerEvent, store: AdministrationStore): void {
        let tabNames: string[] = response.Data["tabNames"];
        if (tabNames != null)
            store.groupTabModel = store.groupTabModel.set("AllTabNamesClickableTextForSpecificContext", tabNames);

        let context = store.groupTabModel.get("ContextForImportClickableText");
        let langClickableText = store.groupTabModel.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        store.groupAction.getAllGroupsWithClickableText(context, lang);
    }

    private getClickableTextDetails(response: ServerEvent, store: AdministrationStore): void {
        let textList: ClickableTextItem[] = response.Data["TextList"];

        if (textList != null)
            store.groupTabModel = store.groupTabModel.set("AllListOfClickableTextDetails", textList);
    }

    private loadAllGroupsWithClickableText(response: ServerEvent, store: AdministrationStore): void {
        let groupResponseList: EmployeeGroup[] = response.Data["GroupsResult"];

        if (groupResponseList != null) {
            store.groupTabModel = store.groupTabModel.set("AllGroupsWithClickableText", groupResponseList.sortByProperty(x => x.Name));
            store.groupTabModel = store.groupTabModel.set("IsImportClickableTextOpen", true);
        }
    }

    private importClickableText(response: ServerEvent, store: AdministrationStore): void {
        let isSuccess: boolean = response.Data["IsSuccess"];
        if (isSuccess) {
            let group = store.groupTabModel.get("EditedGroup");
            window.setTimeout(
                () => store.groupAction.getAllCliackableText(group.Model.Id),
                200
            );
        }
    }

    private getAllClickableText(response: ServerEvent, store: AdministrationStore): void {
        let textList = response.Data["TextList"];

        let group = store.groupTabModel.get("EditedGroup");
        group.Model.ClickableText = textList;

        if (group.Model.ClickableText && group.Model.ClickableText.length > 0)
            group.Model.ClickableText.sortByProperty(x => x.TabOrderIndex);

        store.groupTabModel = store.groupTabModel.set("EditedGroup", group.clone());
    }

    private getClickableTextSpecificUser(response: ServerEvent, store: AdministrationStore): void {
        let textList = response.Data["TextList"];
        let IsRefresh = store.groupTabModel.get("IsRefreshClickableText");
        let IsImportDeleteTexts = response.Data["IsImportDeleteTexts"];

        let editedGroup = store.groupTabModel.get("EditedGroup");
        editedGroup.Model.ClickableText = textList;

        if (editedGroup.Model.ClickableText && editedGroup.Model.ClickableText.length > 0)
            editedGroup.Model.ClickableText.sortByProperty(x => x.TabOrderIndex);

        store.groupTabModel = store.groupTabModel.set("EditedGroup", editedGroup.clone());

        if (!IsRefresh && !IsImportDeleteTexts) {
            store.groupTabModel = store.groupTabModel.set("ClickableTextSpecificUser", textList);
            if (store.groupTabModel.get("GroupEditMode") == GroupEditMode.Edit)
                store.groupAction.createListOfClickableText(editedGroup.Model.ClickableText.sortByProperty(x => x.TabOrderIndex), editedGroup.Model.Id);
        }

        else
            store.groupTabModel = store.groupTabModel.set("IsRefreshClickableText", false);
    }

    private createListOfClickableText(response: ServerEvent, store: AdministrationStore): void {
        store.groupTabModel = store.groupTabModel.set("ClickableTextSpecificUser", null);
    }

    private updateGroupName(response: ServerEvent, store: AdministrationStore): void {
        let isSuccess: boolean = response.Data["IsSuccess"];
        let selectedGroup = store.groupTabModel.get("SelectedGroup");
        let groupName = store.groupTabModel.get("GroupName");

        if (isSuccess) {
            store.groupTabModel = store.groupTabModel.set("GroupName", "");

            let allGroups = store.groupTabModel.get("SearchGroupResult");

            let group = allGroups.filter((e: EmployeeGroupUIModel) => e.Model.Id == selectedGroup.Model.Id).firstOrDefault();
            group.Model.Name = groupName;
            group.Name = groupName;
            store.groupTabModel = store.groupTabModel.set("SearchGroupResult", allGroups.sortByProperty(x => x.Model.Name));
            // refresh group
            store.groupAction.GetGroupInfo(selectedGroup.Model.Id);
            sessionStore.hideGlobalOverlay();
        }
    }
}

export { AdministrationGroupResponseHandler };
